export default __webpack_public_path__ + "static/media/IconUserCancel.5b6f6ae5.svg";